import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';
import ModalEditSpace from './ModalEditSpace';

function SpaceDimesionList({ spaceList, onDelete, setList }) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [selectedItem, setItem] = useState(null);

  const openModalUpdate = (item) => {
    setItem(item);
    setOpen(true);
  };

  const onSave = (values) => {
    setList(
      spaceList.map((item) =>
        item.id === selectedItem.id
          ? {
              ...item,
              industry: values.industry,
              cost: values.cost,
              size: values.size,
              space_number: values.space_number,
            }
          : item,
      ),
    );
    setOpen(false);
  };

  return (
    <TableContainer component={Paper} style={{ borderRadius: 20, marginTop: 20 }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <Box sx={{ fontWeight: 'bold' }}>Industry</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }}>
              <Box sx={{ fontWeight: 'bold' }}>Size</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }}>
              <Box sx={{ fontWeight: 'bold' }}>Number of Spaces</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }}>
              <Box sx={{ fontWeight: 'bold' }}>Price</Box>
            </TableCell>
            <TableCell align="left" xs={{ fontWeight: 600 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {
            // eslint-disable-next-line react/prop-types
            spaceList?.map(
              (row, i) =>
                row.status === AMENITY_SPACE_STATUS.ENABLED && (
                  <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left">{row.industry}</TableCell>
                    <TableCell align="left">{row.size}</TableCell>
                    <TableCell align="left">{row.space_number}</TableCell>
                    <TableCell align="left">
                      <p style={{ color: '#0997BA', fontWeight: 'bold', marginRight: '15%' }}>
                        ${row.cost}
                      </p>
                    </TableCell>
                    <TableCell align="right">
                      <Box>
                        <Box sx={{ paddingRight: '15px', display: 'inline' }}>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => openModalUpdate(row)}>
                            <EditIcon />
                          </IconButton>
                        </Box>
                        <Box sx={{ display: 'inline' }}>
                          <IconButton edge="end" aria-label="delete" onClick={onDelete(row)}>
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ),
            )
          }
        </TableBody>
      </Table>
      {open && (
        <ModalEditSpace
          open={open}
          space={selectedItem}
          handleClose={handleClose}
          onSave={onSave}
        />
      )}
    </TableContainer>
  );
}

SpaceDimesionList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  spaceList: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  setList: PropTypes.func.isRequired,
};

export default SpaceDimesionList;
